import React, { Fragment } from 'react'
import { Translation, Locale } from 'locale'
import { User, ValidationIssue } from 'api'
import { Groupbox } from 'view/components/panels'
import { TextInputField, DialogRow, DialogField } from 'view/components/inputs'
import * as constants from 'view/styles/constants'

interface NotesPanelProps {
  user: User
  validationIssues: ValidationIssue[]
  readOnly: boolean
  onUpdateUser: (user: Partial<User>) => unknown
}

export const NotesPanel: React.FunctionComponent<NotesPanelProps> = props => {
  const { user, validationIssues, readOnly, onUpdateUser } = props

  const handleUpdate = (value: string) => {
    const update = {
      notes: value
    }
    onUpdateUser(update)
  }

  return (
    <Fragment>
      <Groupbox>
        <DialogRow verticalLayout={constants.VerticalLayout.Bottom}>
          <DialogField>
            <TextInputField
              dataTestId={'UserDetailsPanel-TextInputField-Notes'}
              label={Locale.translate(Translation.TC_NOTES)}
              fieldName="notes"
              validationIssues={validationIssues}
              value={user.notes}
              maxLength={constants.notesMaxFieldLength}
              readOnly={readOnly}
              onUpdate={handleUpdate}
            />
          </DialogField>
        </DialogRow>
      </Groupbox>
    </Fragment>
  )
}
